// extracted by mini-css-extract-plugin
export var volunteerCard = "volunteer-module--volunteer-card--3+kYS";
export var volunteerDetails = "volunteer-module--volunteer-details--3BcgC";
export var volunteerImage = "volunteer-module--volunteer-image--BUSQv";